import { FiX } from 'react-icons/fi'

import { Modal } from '~/components/Modal'
import { LicenseExtension } from '~/modules/sales/licenseExtensions/types'

import { LicenseExtensionForm } from './LicenseExtensionForm'

type Props = {
  visible: boolean
  extension: LicenseExtension | null
  onSuccess: () => void
  onDismiss: () => void
}

export const CreateEditLicenseExtensionModal: React.FC<Props> = ({
  visible,
  extension,
  onSuccess,
  onDismiss,
}) => (
  <Modal visible={visible}>
    <div className='grid gap-4 min-w-[400px]'>
      <div className='flex items-center justify-between mb-2'>
        <h1 className='text-xl'>
          {extension ? 'Editar pacote' : 'Novo pacote de licenças'}
        </h1>
        <button
          type='button'
          className='p-2 rounded-full hover:bg-slate-50'
          onClick={onDismiss}
        >
          <FiX size={26} />
        </button>
      </div>

      <LicenseExtensionForm
        extension={extension}
        onSuccess={onSuccess}
        onDismiss={onDismiss}
      />
    </div>
  </Modal>
)
